import { ReactNode } from 'react';
import { Modal, ModalProps } from 'react-bootstrap';

import CustomModal from 'src/components/custom_components/CustomModal/CustomModal';
import CustomModalFooter from 'src/components/custom_components/CustomModal/CustomModalFooter';
import CustomModalHeader from 'src/components/custom_components/CustomModal/CustomModalHeader';

export interface SmallModalTemplateProps extends ModalProps {
  icon: ReactNode;
  iconWrapperClassName: string;
  title: string;
  description: string;
  card?: ReactNode;
  leftButton?: ReactNode;
  rightButton: ReactNode;
}

export default function SmallModalTemplate({
  icon,
  iconWrapperClassName,
  title,
  description,
  card,
  leftButton,
  rightButton,
  ...modalProps
}: SmallModalTemplateProps) {
  return (
    <CustomModal {...modalProps}>
      <CustomModalHeader className="flex-column align-items-start px-4 pt-4 pb-0">
        <div
          className={`d-inline-flex align-items-center justify-content-center rounded p-3 mb-2 ${iconWrapperClassName}`}
        >
          {icon}
        </div>
        <Modal.Title as="h4">{title}</Modal.Title>
      </CustomModalHeader>
      <Modal.Body className="px-4 pt-2 pb-2">
        <p>{description}</p>
        {card}
      </Modal.Body>
      <CustomModalFooter className="px-4 pb-4">
        {leftButton}
        <span className="ms-auto">{rightButton}</span>
      </CustomModalFooter>
    </CustomModal>
  );
}
